import { Switch, Route, useRouteMatch } from 'react-router-dom';

import { useHelpAssistantConversation, useHelpAssistantPanel } from '@/app/helpArticle/_hooks';

import HelpAssistantContext from '@/app/helpArticle/_context';
import ViewHelpAssistantSheet from '@/app/helpArticle/ViewHelpAssistantSheet';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const ListComponent = LoadComponentWithRetry(() => import('./ListHelpCategoriesPage'));
const ListCategoryComponent = LoadComponentWithRetry(() => import('./ListHelpCategoryArticlesPage'));
const ViewComponent = LoadComponentWithRetry(() => import('./ViewHelpArticlePage'));

// An article's URL carries only its slug, not its category, so a link someone
// shared keeps working if the article moves to another category. `:slug+`
// because some slugs contain a `/`.
//
// The assistant lives here, above the pages, so its conversation survives
// moving between them.
const Routes = () => {
  const { path } = useRouteMatch();
  const conversation = useHelpAssistantConversation();
  const panel = useHelpAssistantPanel();

  return (
    <HelpAssistantContext.Provider value={{ conversation, panel }}>
      <Switch>
        <Route path={`${path}/article/:slug+`} component={ViewComponent} />
        <Route path={`${path}/:categorySlug`} component={ListCategoryComponent} />
        <Route path={path} component={ListComponent} />
      </Switch>
      {panel.isOpen && <ViewHelpAssistantSheet onClose={panel.close} />}
    </HelpAssistantContext.Provider>
  );
};

export default Routes;
